import React  from 'react';
import { SpeakUrl } from '../../libs/env';
import { getCssVariableValue } from '../../speech_pages/components/cssVariablesValue/cssUtils';
export default function AudioVisualizer(props) {
  const canvas = React.useRef(null);
  let className = "canvas-width";
  let strokeColor = 'rgba(245, 47, 55, 1)';
  if (window.location.pathname.includes(SpeakUrl))
  {
    className ="speak-canvas-width";
    if(props.modalTest){
      className="col-12"
    }
    strokeColor = getCssVariableValue('--background-color');
  }
  const draw = () => {
    if (!canvas.current) { return; }
    const height = canvas.current.height;
    const width = canvas.current.width;
    const context = canvas.current.getContext('2d');
    const displayCount = props.audioData.length;
    const sliceWidth = (width * 1.0) / displayCount;

    let x = 0;
    context.lineWidth = 1.5;
    context.strokeStyle = strokeColor;
    context.clearRect(0, 0, width, height);
    for (let i = 0; i < displayCount; i ++) {
      context.beginPath();
      const y = ((props.audioData[i] - 128) / 100.0) * height;
      context.moveTo(x, height / 2 - Math.abs(y));
      context.lineTo(x, height / 2 + Math.abs(y));
      context.stroke();
      x += sliceWidth;
    }
  }
  draw();

  return <canvas class={className}  height={props.height} ref={canvas} />;
}